var exports = {
  "wrapper": "xaee3c4fa--59a949--wrapper",
  "_gray": "xaee3c4fa--59a949--_gray",
  "_blue": "xaee3c4fa--59a949--_blue",
  "_pink": "xaee3c4fa--59a949--_pink",
  "_green": "xaee3c4fa--59a949--_green",
  "_lightblue": "xaee3c4fa--59a949--_lightblue",
  "image-wrapper": "xaee3c4fa--59a949--image-wrapper",
  "content": "xaee3c4fa--59a949--content",
  "text": "xaee3c4fa--59a949--text",
};

module.exports = exports;
